export { default } from './CourseBanner';
